class FAQ {
    constructor() {
        this.setFAQ();
    }

    setFAQ() {
        const questionElements = document.querySelectorAll('.faq .question-container');
        questionElements.forEach((questionElement) => {
            const question = questionElement.querySelector('.question');
            question.addEventListener('click', () => this.toggleQuestion(questionElement));
        });

        document.addEventListener('in-view-block-faq', (event) => {
            setTimeout(() => {
                this.openFirst(event.target);
            }, 900);
        });
    }

    openFirst(block) {
        const first = block.querySelector('.question-container');
        if (first) first.classList.add('open');
    }

    toggleQuestion(questionElement) {
        const isOpen = questionElement.classList.toggle('open');

        // Close the other questions in the same FAQ
        if (isOpen) {
            questionElement.parentElement.querySelectorAll('.question-container.open').forEach((openElement) => {
                if (openElement !== questionElement) {
                    openElement.classList.remove('open');
                }
            });
        }

        // Allow time for the FAQ animation to complete before refreshing ScrollTrigger
        setTimeout(() => {
            document.dispatchEvent(new CustomEvent('refreshScrollTrigger'));
        }, 700);

        // Extra timeout to ensure scroll trigger refreshes after any potential animation has completed
        setTimeout(() => {
            document.dispatchEvent(new CustomEvent('refreshScrollTrigger'));
        }, 2000);
    }
}
new FAQ();
